<template>
    <div v-if="value.text" id="thanks" class="thanks_wrapper">
        <div class="text" v-html="value.text" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
